import React, { useEffect, useState } from 'react';
import CandidateCardsList from '../components/CandidateCardsList';
import {  fetchActiveDepartments, GetCandidate, GetDemandPlanning } from '../services/apiService';
import LoadingSpinner from '../components/LoadingSpinner';
import { getDepartmentIdFromToken, getToken } from '../services/authService';

const HiringapprovalPage = () => {
  const [candidates, setcandidates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [demandPlans, setDemandPlans] = useState([]);
  const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});
 useEffect(() => {
    
   const userRole = getToken();
const loadDepartments = async () => {
  try {
    const deptData = await fetchActiveDepartments();

    const isRestricted = userRole?.IsDepartmentRestricted === "True";
    const isBusinessOwner = userRole?.RoleName === "Business Owner";

    if (isRestricted && isBusinessOwner) {
      const departmentId = getDepartmentIdFromToken();

      setDepartments(
        deptData.filter(
          dept => String(dept.department_id) === String(departmentId)
        )
      );
    } else {
      setDepartments(deptData);
    }

  } catch (err) {
    console.error("Failed to load departments:", err);
  }
};

 
 
 
const loadDemandPlan = async () => {
  try {
    const currentYear = new Date().getFullYear();
    const dplan = await GetDemandPlanning(currentYear);

    if (userRole?.IsDepartmentRestricted === "True") {
      if (userRole?.RoleName === "Business Owner") {
        const departmentId = getDepartmentIdFromToken();

        setDemandPlans(
          dplan.filter(
            dept => String(dept.department_id) === String(departmentId)
          )
        );
      } else {
        setDemandPlans(dplan);
      }
    } else {
      setDemandPlans(dplan);
    }

  } catch (err) {
    console.error("Failed to load departments:", err);
  }
};

 
    const loadCandiates = async () => {
        try {
          setLoading(true);
          const userRole = getToken();
          const requests = await GetCandidate();
      
          // Filter candidates based on user's role
          let filteredRequests = requests.filter(
            (request) => request.approval_level_name === userRole.role 
          );

            if(userRole === "Business Owner"){
         if (userRole.IsDepartmentRestricted === "True") { 
            const departmentId = getDepartmentIdFromToken();
            
              filteredRequests = filteredRequests.filter(
                (request) => String(request.department_id)  === String(departmentId)
              );
          }
        }
         
          setcandidates(filteredRequests);
        } catch (err) {
          setErrors("Failed to load hiring requests");
        } finally {
          setLoading(false);
        }
      };
      
 
     loadDepartments();
     loadCandiates();
     loadDemandPlan();
   }, []);

  if (loading) return <LoadingSpinner label="Loading Approvals" />;

  return (
        <div className="
  bg-white
  mx-4
  sm:h-[72vh] sm:pt-4 sm:px-4 sm:rounded-t-[32px]
  md:h-[74.5vh] md:pt-8 md:px-[calc(5%-1rem)] md:rounded-t-[40px]
  lg:h-[74.5vh] lg:px-[calc(6%-1rem)]
  xl:h-[100%] xl:pt-24 xl:px-[calc(2.5%-1rem)] xl:rounded-t-[48px]
  2xl:h-[74.5vh] 2xl:px-[calc(8%-1rem)]
  3xl:h-[74.5vh] 3xl:px-[calc(8%-1rem)]
  4xl:h-[74.5vh] 4xl:px-[calc(10%-1rem)]
       ">
 
     
<CandidateCardsList
  candidates={candidates}
  departments={departments}
  demandPlans={demandPlans}
  showStatusFilter={false}
  fixedStatus="Send For Approval"
/>
    </div>
  );
};

export default HiringapprovalPage;
